<script setup>
import { useAlert } from 'dashboard/composables';
import SettingsLayout from '../SettingsLayout.vue';
import BaseSettingsHeader from '../components/BaseSettingsHeader.vue';
import { ref, onMounted, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import { useAdmin } from 'dashboard/composables/useAdmin';

const { t } = useI18n();
const { isAdmin } = useAdmin();
const route = useRoute();

const inboxMetaList = ref([]);
const isLoading = ref(false);

const loadInboxMeta = async () => {
  isLoading.value = true;
  const accountId = route.params.accountId;
  console.log('Loading inbox meta for account:', accountId);
  
  try {
    const url = `/api/v1/accounts/${accountId}/config_ouroboros/list`;
    console.log('Fetching URL:', url);
    
    const response = await window.axios.get(url);
    
    console.log('Response status:', response.status);
    console.log('Response data:', response.data);
    
    inboxMetaList.value = response.data.inbox_meta_list || [];
    console.log('Inbox meta list:', inboxMetaList.value);
  } catch (error) {
    console.error('Error loading inbox meta:', error);
    console.error('Error details:', error.response);
    if (error.response) {
      console.error('Status:', error.response.status);
      console.error('Data:', error.response.data);
    }
    useAlert(t('OUROBOROS.LIST.ERROR_LOADING'));
  } finally {
    isLoading.value = false;
  }
};

onMounted(() => {
  console.log('Component mounted, calling loadInboxMeta...');
  loadInboxMeta();
});

// Recarrega quando o componente é ativado (após navegação)
import { onActivated } from 'vue';
onActivated(() => {
  console.log('Component activated, reloading data...');
  loadInboxMeta();
});

// Observa mudanças na rota para recarregar dados
watch(() => route.path, () => {
  if (route.name === 'settings_ouroboros_list') {
    console.log('Route changed to ouroboros list, reloading data...');
    loadInboxMeta();
  }
});
</script>

<template>
  <SettingsLayout
    :no-records-found="!inboxMetaList.length"
    :no-records-message="$t('OUROBOROS.LIST.404')"
    :is-loading="isLoading"
  >
    <template #header>
      <BaseSettingsHeader
        :title="$t('OUROBOROS.HEADER')"
        :description="$t('OUROBOROS.DESCRIPTION')"
      />
    </template>
    <template #body>
      <table
        class="min-w-full overflow-x-auto divide-y divide-slate-75 dark:divide-slate-700"
      >
        <thead>
          <tr>
            <th class="py-4 ltr:pr-4 rtl:pl-4 text-left">
              {{ $t('OUROBOROS.LIST.TABLE_HEADER.INBOX') }}
            </th>
            <th class="py-4 text-left">
              {{ $t('OUROBOROS.LIST.TABLE_HEADER.CONVERSION_CONDITION') }}
            </th>
            <th class="py-4 text-right">
              {{ $t('OUROBOROS.LIST.TABLE_HEADER.ACTIONS') }}
            </th>
          </tr>
        </thead>
        <tbody
          class="divide-y divide-slate-25 dark:divide-slate-800 flex-1 text-slate-700 dark:text-slate-100"
        >
          <tr v-for="item in inboxMetaList" :key="item.id">
            <td class="py-4 ltr:pr-4 rtl:pl-4">
              <div>
                <span class="block font-medium">
                  {{ item.inbox_name }}
                </span>
                <span class="text-xs text-slate-500">
                  ID: {{ item.inbox_id }}
                </span>
              </div>
            </td>

            <td class="py-4">
              <span class="text-sm text-slate-600 dark:text-slate-400">
                {{ item.conversion_condition || $t('OUROBOROS.LIST.NOT_CONFIGURED') }}
              </span>
            </td>

            <td class="py-4">
              <div class="flex gap-1 justify-end">
                <router-link
                  :to="{
                    name: 'settings_ouroboros_edit',
                    params: { inboxId: item.inbox_id },
                  }"
                >
                  <woot-button
                    v-if="isAdmin"
                    v-tooltip.top="$t('OUROBOROS.LIST.CONFIGURE')"
                    variant="smooth"
                    size="tiny"
                    icon="settings"
                    color-scheme="secondary"
                    class-names="grey-btn"
                  />
                </router-link>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </template>
  </SettingsLayout>
</template>